// storeSetupUtils.js
import api from "../api";

export const checkStoreSetupStatus = async ({ navigate, location, setSetupStatus }) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get("/vendor/store-setup-status/", {
      headers: { Authorization: `Bearer ${token}` },
    });

    setSetupStatus(response.data);

    if (
      (!response.data.payment || !response.data.delivery || !response.data.product || !response.data.mobile) &&
      location.pathname !== "/seller/setup"
    ) {
      navigate("/seller/setup");
    }
  } catch (error) {
    //console.error("Error checking store setup:", error);
  }
};
